import { render, staticRenderFns } from "./ChooseTaskDialog.vue?vue&type=template&id=6007a15e&scoped=true"
import script from "./ChooseTaskDialog.vue?vue&type=script&lang=js"
export * from "./ChooseTaskDialog.vue?vue&type=script&lang=js"
import style0 from "./ChooseTaskDialog.vue?vue&type=style&index=0&id=6007a15e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6007a15e",
  null
  
)

export default component.exports